import classNames from 'classnames';
import { useCallback } from 'react';

import { InlineVideoStoryblok } from '../types/generated-storyblok';
import { useAnalyticsEmitter } from '../utils/analytics/emitter';
import { InlineVideo } from './InlineVideo/InlineVideo';

interface ContentBlockVideoProps {
  blok: InlineVideoStoryblok | InlineVideoBlok;
}

export const ContentBlockVideo = ({ blok }: ContentBlockVideoProps) => {
  const [emitter] = useAnalyticsEmitter();

  const handlePlay = useCallback(() => {
    emitter('', 'video clicked', {
      title: blok.alt || blok.cover?.alt || '',
    });
  }, [blok, emitter]);

  return (
    <div
      className={classNames('mx-auto w-full', {
        'max-w-5xl': blok.ratio === '1/1',
        'max-w-3xl': blok.ratio === '4/5',
        'max-w-lg': blok.ratio === '9/16',
      })}
    >
      <InlineVideo
        autoplay={blok.autoplay}
        cover={blok.cover.filename}
        onPlay={handlePlay}
        platform={blok.platform}
        playButton={blok?.playButton ?? false}
        playButtonLabel={blok.playButtonLabel}
        ratio={blok.ratio}
        title={(blok.alt || blok.cover?.alt) ?? ''}
        videoId={blok.videoId}
      />
    </div>
  );
};
